// pc客户端函数集合
import { bridge } from '@meitu/pc-bridge';

// 读取本地缓存
export async function getLocalStorage(key: string) {
    const value = await bridge.getLocalStorage(key);
    return value;
}

// 获取服务端下发的真实gid
export async function getServerGid() {
    const value = await bridge.getServerGid();
    return value;
}

// 打开系统浏览器
export function openBrowser(url: string) {
    bridge.openBrowser(url);
}

export function logout() {
    bridge.logout();
}

export function relogin(value: number) {
    bridge.openLoginWithFailRedirect();
}

export function downloadSuccess(data: any) {
    bridge.saveImageToPhotosAlbum(data);
}
